









































import { Component, Vue, Emit, Watch, Prop } from 'vue-property-decorator';
import { l3draggable, l3droppable } from "@/directives/l3dragDrop";
// components
import CompImage from '../ExerciseComponents/CompImage.vue';
import ExpandableCard from '../Shared/ExpandableCard.vue';
import TusFileDrop from "@/components/Shared/TusFileDrop.vue";
// interfaces
import { namespace } from 'vuex-class';
import { ExerciseVM } from '@/interfaces/ExerciseVM';
import { CourseElementVm } from '@/interfaces/CourseElementVm';
import { FileDetailsVm } from '@/interfaces/FileDetailsVm';
import MarkdownEditor from '../Shared/MarkdownEditor.vue';
import TusFileUploadOverlay from '../Shared/TusFileUploadOverlay.vue';

const globals = namespace("globals");

@Component({
    components: {
      CompImage,
      ExpandableCard,
      TusFileDrop,
      MarkdownEditor,
      TusFileUploadOverlay
    },
    directives: { l3draggable, l3droppable }
  })
  export default class ImageElement extends Vue {
  @Prop() element!: CourseElementVm;

  @globals.Getter selectedExercise!: ExerciseVM;

  isBusy = false;
  showMarkdownEditor = false;
  fileToUpload: File | null = null;

  mounted() {
  }

  onUploaded(filePath: string | null) {
    if (!filePath) return;
    this.element.contentUrl = filePath;
    this.element.aiSummary = "";
    this.element.altText = "";
    this.element.invisible = false;
  }

  onCancelled() {
    // this.fileToUpload = null;
  }

  // open hidden file input
  openFileDialog() {
    const input = this.$refs.fileInput as HTMLInputElement | undefined;
    if (input) input.click();
  }

  // upload the selected image file like a dropped file
  onFileSelected(e: Event) {
    const input = e.target as HTMLInputElement;
    if (!input || !input.files || input.files.length === 0) return;
    const file = input.files[0];
    input.value = '';
    if (!file.type.startsWith("image/")) {
      this.$store.commit("ux/SB_FAILURE", {
        message: "Bei dieser Datei handelt es sich nicht um ein Bild.",
        timeout: 0
      });
      return;
    }
    this.fileToUpload = file; // trigger upload overlay
  }

  get unsplashUrl() {
    // choose source text
    const raw = (this.element.imageLibrarySearchText && this.element.imageLibrarySearchText.trim() != "")
      ? this.element.imageLibrarySearchText.trim() : this.element.text?.trim();

    if (!raw || raw == "") {
      return "https://unsplash.com/de/s/fotos/Business?orientation=landscape&license=free";
    }

    // normalize, remove punctuation and symbol characters, then replace whitespace with '-'
    // uses Unicode property escapes to remove punctuation and symbols
    const sanitized = raw.normalize('NFC').replace(/[\p{P}\p{S}]/gu, '');
    let query = sanitized.replace(/\s+/g, '-');

    return `https://unsplash.com/de/s/fotos/${query}?orientation=landscape&license=free`;
  }

  get dropOptions() {
    return {
      accept: (data: any, ev?: DragEvent) => {
        const types = ev?.dataTransfer?.types ? Array.from(ev.dataTransfer.types) : [];
        const hasFiles = types.includes('Files');
        const hasImageGroup = types.includes('application/x-image-file-details') || types.includes('application/x-file-details');
        if (!data && !hasFiles && !hasImageGroup) return false;
        // Check for FileDetailsVm
        if (data?.fileType && (data.fileType == "Image")) return true;
        // Check for raw file array (dragged from OS / Browser)
        if (Array.isArray(data) && data[0] && data[0].name && data[0].type) return true;
        if (hasFiles || hasImageGroup) return true;
        return false;
      },
      hoverClass: "drop-hover",
      transferTypes: ["Files"],
      targetGroups: ["image-file-details"],
      onDrop: (data: any) => {
        // console.log("Dropped data:", data);
        // Check for FileDetailsVm
        if (data?.fileType && (data.fileType == "Image")) {
          let fileDetails: FileDetailsVm = data;
          this.element.contentUrl = fileDetails.filePath;
          this.element.aiSummary = fileDetails.aiSummary || "";
          this.element.altText = "";
          this.element.invisible = false;
        } else
        // Check for raw file array (dragged from OS / Browser). The file list is converted to array in the directive
        if (Array.isArray(data) && data[0] && data[0].name && data[0].type) {
          // Check that it's an image file
          if (!data[0].type.startsWith("image/")) {
            this.$store.commit("ux/SB_FAILURE", {
              message: "Bei dieser Datei handelt es sich nicht um ein Bild.",
              timeout: 0
            });
            return;
          }
          this.fileToUpload = data[0]; // trigger upload overlay
        }
      }
    };
  }

  openMarkdownEditor() {
    this.showMarkdownEditor = true;
  }

  openUnsplash() {
    const url = this.unsplashUrl;
    if (typeof window !== 'undefined' && window.open) {
      window.open(url, '_blank', 'noopener,noreferrer,width=1000,height=800');
    // } else if (typeof globalThis !== 'undefined' && (globalThis as any).open) {
    //   (globalThis as any).open(url, '_blank', 'noopener,noreferrer,width=1000,height=800');
    } else {
      // no window available (SSR) — fallback: log or handle gracefully
      // eslint-disable-next-line no-console
      console.warn('Cannot open Unsplash: no window object available');
    }
  }
}
